<template>
  <div :class="classnames">
    <popup @openchange="handlePopupOpenChange">
      <template slot="control">
        <vue-button :isActive="isPopupOpen">
          <template slot="text">Edit</template>
          <template slot="icon">
            <svg-icon-caret-down height="8" width="13" />
          </template>
        </vue-button>
      </template>

      <template slot="content">
        <menu-list>
          <template v-for="(item, index) in items">
            <a :class="`${ns}__link`" :href="item.url">
              {{ item.text }}
            </a>
          </template>
        </menu-list>
      </template>
    </popup>
  </div>
</template>

<script>
  import MenuList from '@/components/MenuList'
  import Popup from '@/components/Popup/Popup'
  import VueButton from '@/components/VueButton'

  import SvgIconCaretDown from '@/svgs/SvgIconCaretDown'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'toolbar-edit-menu'

  export default {
    name: 'ToolbarEditMenu',
    components: {
      'menu-list': MenuList,
      'popup': Popup,
      'svg-icon-caret-down': SvgIconCaretDown,
      'vue-button': VueButton
    },
    mixins: [ bem ],
    props: {
      items: {
        type: Array
      }
    },
    data: function () {
      return {
        isPopupOpen: false
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handlePopupOpenChange: function (isPopupOpen) {
        this.isPopupOpen = isPopupOpen
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ToolbarEditMenu.vue